import { CmsComponentProps, IProperties } from '@/types/cms';
import { FC } from 'react';
import dynamic from 'next/dynamic';

const DynamicLayoutLar = dynamic(() => import('./layout-lar'));

export type SubCompProps = {
  onFetch: (state: 'loading' | 'done' | 'error') => void;
  postUrl: string;
  componentDataSourceKey: string;
  cmsComponentKey: string;
  properties: IProperties;
  componentPos: number;
  subComponentPos: number;
  layoutKey: string;
};

const LayoutLar: FC<CmsComponentProps> = props => {
  return <DynamicLayoutLar {...props} />;
};

export default LayoutLar;
